'use client';

import Link from 'next/link';

import Facebook from '@/components/icons/Facebook';
import GitHub from '@/components/icons/GitHub';
import LinkedIn from '@/components/icons/LinkedIn';
import Logo from '@/components/icons/Logo';
import Reddit from '@/components/icons/Reddit';
import Twitter from '@/components/icons/Twitter';

import { motion } from 'framer-motion';

export default function Footer() {
  return (
    <motion.footer
      className='bg-background mx-auto max-w-[1920px] px-4'
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false }} // Allow the animation to be triggered on the first scroll down only
      transition={{ duration: 0.5 }}>
      <div className='border-border text-foreground grid grid-cols-1 gap-8 border-b py-12 transition-colors duration-150 md:grid-cols-12'>
        <div className='col-span-1 flex justify-center px-6 md:col-span-2 md:justify-start'>
          <Link
            href='/'
            className='flex flex-initial items-center font-bold'>
            <span className='mr-4'>
              <Logo
                className='h-10 w-10 sm:h-12 sm:w-12 md:h-16 md:w-16'
                style={{ width: '40px', height: '40px' }}
              />
            </span>
            <span
              className='text-brand-dark dark:text-brand-dark-text-primary text-2xl font-bold sm:text-3xl md:text-4xl font-serif'
              style={{ fontFamily: "'Lora', serif" }}>
              Bioinfometrics
            </span>
          </Link>
        </div>
        <div className='col-span-1 flex justify-center px-6 md:col-span-10 md:justify-end'>
          <div className='mb-4 flex items-center space-x-4 md:mb-0'>
            <a
              aria-label='Github Repository'
              href='https://github.com/iMartinDav'
              className='text-foreground hover:text-brand-accent'>
              <GitHub className='h-6 w-6 transform transition-transform duration-300 hover:scale-110 hover:rotate-6 sm:h-8 sm:w-8' />
            </a>
            <a
              aria-label='Twitter Profile'
              href='https://x.com/bioinfometrics'
              className='text-foreground hover:text-[#1DA1F2]'>
              <Twitter className='h-6 w-6 transform transition-transform duration-300 hover:scale-110 hover:rotate-6 sm:h-8 sm:w-8' />
            </a>
            <a
              aria-label='LinkedIn Profile'
              href='https://www.linkedin.com/company/bioinfometrics/about'
              className='text-foreground hover:text-[#0077B5]'>
              <LinkedIn className='h-6 w-6 transform transition-transform duration-300 hover:scale-110 hover:rotate-6 sm:h-8 sm:w-8' />
            </a>
            <a
              aria-label='Facebook Page'
              href='https://www.facebook.com/profile.php?id=61560884607940&mibextid=LQQJ4d'
              className='text-foreground hover:text-[#1877F2]'>
              <Facebook className='h-6 w-6 transform transition-transform duration-300 hover:scale-110 hover:rotate-6 sm:h-8 sm:w-8' />
            </a>
            <a
              aria-label='Reddit Community'
              href='https://www.reddit.com/user/Bioinfometric/'
              className='text-foreground hover:text-[#FF4500]'>
              <Reddit className='h-6 w-6 transform transition-transform duration-300 hover:scale-110 hover:rotate-6 sm:h-8 sm:w-8' />
            </a>
          </div>
        </div>
      </div>
      <div className='flex flex-col items-center justify-between space-y-4 py-6 md:flex-row md:space-y-0'>
        <div className='text-brand-dark dark:text-brand-dark-text-secondary flex items-center'>
          <span className='text-sm sm:text-base'>
            &copy; {new Date().getFullYear()} Bioinfometrics, Inc. All rights
            reserved.
          </span>
        </div>
      </div>
    </motion.footer>
  );
}
